import React from "react";
import PropertyForm from "../property/PropertyForm";

const WorkflowProviderDesigner = ({
  workflow,
  setWorkflowComponentValues
}) => {
  if (!workflow || !workflow.steps || workflow.steps.length === 0) return null;

  const activeStep = workflow.getActiveStep();
  if (!activeStep || !activeStep.form || activeStep.locked) return null;

  const autoFill = activeStep.form.autoFill;
  if (!autoFill || autoFill.length === 0) return null;

  const fieldInfo = {};
  const layout = [];

  autoFill.forEach(({ label, values }, idx) => {
    const fieldName =
      activeStep.component.component + " item " + idx + " " + label;
    fieldInfo[fieldName] = {
      label,
      editor: "button",
      onClick: () => {
        setWorkflowComponentValues(values, label);
      }
    };
    layout.push(fieldName);
  });

  const pform = {
    section: {
      padding: 1,
      paddingBottom: 2
    },
    header: {
      paddingBottom: 1
    },
    field: {
      paddingBottom: 1
    },
    hideCancel: true,
    hideReset: true,
    hideSave: true,
    sections: [
      {
        title: "Autofill",
        layout
      }
    ],
    fieldInfo
  };

  return <PropertyForm {...pform} />;
};

export default WorkflowProviderDesigner;
